import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { AgentCounterDataObj } from './agent-counter.model';

@Injectable({
    providedIn: 'root'
})
export class AgentCounterService {

    constructor(
        private cvApiService: CVApiService
    ) { }

    // Service Methods
    async LoadData(moduleKey: string , isAutoRefresh = false, isFirstLoad = false) {
        let renderEndPoint: string;
        try {
            renderEndPoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
        } catch (error) {
            console.error("Failed getting module render end point");
            throw error;
        }
        try {
            const url = "/api/v2/dashboards/modules/agentCounterData/" +
                moduleKey + "?isAutoRefresh=" + !!isAutoRefresh + "&isFirstLoad=" + !!isFirstLoad;
            const response = await this.cvApiService.get<AgentCounterDataObj>(url, renderEndPoint);
            if (response.status_code >= 200 && response.status_code < 300) {
                return response.data;
            }
            else {
                throw response;
            }
        } catch (error) {
            console.error("Failed getting agent counter data");
            throw error;
        }
    }
}
